import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import EditMeetingComponent from "../../../components/Meetings/Edit";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import { getDateTime } from "../../../helpers/Common_functions";

const Edit = (props) => {
  const {
    location,
    errorMessage,
    UpdateMeeting,
    rooms,
    GetAvailableRooms,
    MeetingDetails,
    meeting,
  } = props;

  const { meetingId } = useParams();

  const [agenda, setAgenda] = React.useState(location?.state?.agenda);
  const [reminder, setReminder] = React.useState(location?.state?.reminder);
  const [start, setStart] = React.useState(getDateTime(location?.state?.start));
  const [end, setEnd] = React.useState(getDateTime(location?.state?.end));
  const [name, setName] = React.useState(location?.state?.name);
  const [room, setRoom] = React.useState(location?.state?.roomId);
  const [type, setType] = React.useState(location?.state?.type);
  const [venue, setVenue] = React.useState(location?.state?.venue);
  const [loading, setLoading] = React.useState(false);
  const [validationMessage, setValidationMessage] = React.useState();
  const [field, setField] = React.useState("");
  const [Room, setRoomDetails] = React.useState(location?.state?.Room);
  useEffect(
    () => {
      MeetingDetails(meetingId);
    },
    [MeetingDetails, meetingId]
  );

  useEffect(() => {
    if (meeting) {
      setStart(getDateTime(meeting.start));
      setEnd(getDateTime(meeting.end));
      setRoom(String(meeting.roomId));
      setType(meeting.type);
      setVenue(meeting.venue);
      setReminder(meeting.reminder);
      setName(meeting.name);
      setAgenda(meeting.agenda);
      setRoomDetails(meeting.Room);
    }
  }, [meeting, rooms]);

  useEffect(() => {
    if (errorMessage) setLoading(false);
  }, [errorMessage]);

  useEffect(() => {
    if (start) {
      GetAvailableRooms(start);
    }
  }, [GetAvailableRooms, start]);
  let history = useHistory();
  const onSubmit = async (
    // e: { preventDefault: () => void },
    duration
  ) => {
    // e.preventDefault();   
    const info = {
      id: meetingId,
      start,
      end,
      venue,
      duration,
      roomId: room,
      type,
      name,
      agenda,
      participants: meeting?.MeetingParticipants ?? location?.state?.MeetingParticipants,
      reminder,
      status: (meeting?.status ?? location?.state?.status) === "canceled" ? "scheduled" : '',
      Room: meeting?.Room ?? location?.state?.Room,

    };

    const response = await UpdateMeeting(info);
    if (response === 200) {
      history.push(`/admin/meeting/details/${meetingId}`)
    }
  };

  return (
    // <div {...props}>
    <EditMeetingComponent
      agenda={agenda}
      setAgenda={setAgenda}
      setStart={setStart}
      start={start}
      setEnd={setEnd}
      end={end}
      setName={setName}
      name={name}
      setType={setType}
      type={type}
      venue={venue}
      setVenue={setVenue}
      room={room}
      setRoom={setRoom}
      reminder={reminder}
      setReminder={setReminder}
      rooms={rooms}
      onSubmit={onSubmit}
      setLoading={setLoading}
      loading={loading}
      Room={Room}
      errorMessage={errorMessage}
      validationMessage={validationMessage}
      field={field}
      setField={setField}
    />
    // </Layout>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Edit);
